import axios from "axios";

export const API_URL = import.meta.env.VITE_ZAPI_API_URL;

const $api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});

export default $api;
